module.exports = __webpack_public_path__ + "img/uniform-martial-arts.9dd41b85.svg";